import Default from '../Pages/DashBoard/Default/Default';
import Order from '../Pages/DashboardQeza/Order/Order';

export const csRoutes = [
    { path: `${process.env.PUBLIC_URL}/dashboard/`, Component: <Default /> },
    { path: `${process.env.PUBLIC_URL}/orders/`, Component: <Order /> },
];